<script>
import { VBtn, VBtnToggle } from 'vuetify/components'

export default {
  name: 'SegmentedControl',
  components: { VBtn, VBtnToggle },
  props: {
    items: {
      type: [Array, Object],
      required: true
    },
    modelValue: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: undefined
    }
  },
  emits: ['update:modelValue'],
  computed: {
    value: {
      get () {
        return this.modelValue
      },
      set (value) {
        this.$emit('update:modelValue', value)
      }
    }
  }
}
</script>

<template>
  <VBtnToggle
    v-model="value"
    mandatory
    divided
    rounded="pill"
    border
  >
    <VBtn
      v-for="(label, key) in items"
      :key="key"
      active-color="blue-grey-lighten-5"
      :prepend-icon="key === value ? '$complete' : undefined"
      :ripple="false"
      :value="key"
      :size="size"
    >
      <span class="text-subtitle-2">{{ label }}</span>
    </VBtn>
  </VBtnToggle>
</template>

<style lang="scss">
.v-btn-group--density-default.v-btn-group {
  height: 32px;
  min-width: fit-content;
}
</style>
